// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__PVqt1","box":"styles_box__llLca","icon":"styles_icon__xZkT_"};